import {
  IUserBookingStatus,
  EType as EStatusType,
} from '../repositories/newbuilding-calltracking/entities/MobileApps/UserBookingStatus';
import {
  IOrderStatusSchema,
  EType as EOrderStatusType,
} from '../repositories/newbuilding-card/entities/flat_view_order/OrderStatusSchema';

export const transformUserBookingStatus = (data: IUserBookingStatus): IOrderStatusSchema => {
  return {
    type: data.type === EStatusType.SignedUp ? EOrderStatusType.SignedUp : EOrderStatusType.NoActive,
    description: data.description,
  };
};
